import React, { useState, useEffect } from "react";
import CustomInput from "../../../Components/Common/CustomInput";
import CustomButton from "../../../Components/Common/CustomButton";
import CustomSelect from "../../../Components/Common/CustomSelect"; 
import {Country,State, City} from "../../../util/data"
import toast from "react-hot-toast";
import { editProfile } from "../../../redux/users/userSlice";
import { useDispatch, useSelector } from "react-redux";

const Contact = ({
  setActiveTab,
  setFormData,
  ContactDataForm,
  ContactDataState,
  handleUserContact,
  userType
}) => {
  const [formValues, setFormValues] = useState(ContactDataState || {});
  const [invalidFields, setInvalidFields] = useState({});
 const dispatch =  useDispatch();
 const {singleUser,isLoading} = useSelector((state) => state.users);
// const[countries,setCountries]=  useState(Country)
const[stats,setStats]=  useState(State)
const[cities,setCities]=  useState(City)
  useEffect(() => {
    setFormValues(ContactDataState || {});
  }, [ContactDataState]);

  const handleChange = (name, value,selectedOption) => {
    if (name === "zipCode") {
      value = value.replace(/[^0-9]/g, "").slice(0, 6);
    }

    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
    setInvalidFields((prev) => ({
      ...prev,
      [name]: "",
    }));
    if(selectedOption){
      if(name==="country"){
        const updatedStats =  State.filter((elm)=>elm.country_id==selectedOption.id)
    
        setStats(updatedStats)
      }else if(name==="state"){
        const updatedCities =  City.filter((elm)=>elm.state_id==selectedOption.id)
      setCities(updatedCities)
      }
    }
  };  
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    const newInvalidFields = {};
    let isValid = true;
    const zipCodeRegex = /^[0-9]{6}$/;
    Object.keys(formValues).forEach((key) => {
      if (formValues[key] === "" && key !== "Address2") {
        newInvalidFields[key] = `Please Enter ${key}`;
        isValid = false;
      }
    });

    if (formValues.zipCode && !zipCodeRegex.test(formValues.zipCode)) {
      newInvalidFields.zipCode = "Please enter 6 digits for ZIP code";
      isValid = false;
    }

    setInvalidFields(newInvalidFields);

    if (isValid) {
      setFormData((prev) => ({
        ...prev,
        "ContactData": { ...formValues },
      }));
      const { Address1, Address2, ...restAddressDetail} = formValues
      const body ={
        address: {
          addressLine1: Address1,
          addressLine2: Address2,
          ...restAddressDetail
        },
      }
     try {
      await dispatch(editProfile({
        body, 
       id: singleUser._id,
       userId: singleUser?.userId,
       })
                ).unwrap();

      setActiveTab(() => 2);
     } catch (error) {
      console.log("Profile submission error:", error);
        toast.error(
          error?.message || "An error occurred while saving the profile"
        );
     }

        
          // handleUserContact(formValues)
     
    }
  };

  return (
    <form
      className="pb-6 max-h-full px-3 customScrollbar"
      onSubmit={handleSubmit}
    >
      {ContactDataForm?.map((elm, index) => (
        <div key={index} className="pl-2 pb-4 border-b-2 border-slate-100">
          <div className="py-1 ">
            <h1 className="text-lg font-semibold text-gray-800">
              {elm.heading}
            </h1>
            <p className="text-sm text-gray-500 opacity-90">{elm.subHeading}</p>
          </div>
          <div className="px-4 mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-x-7 gap-y-4">
            {elm.forminput.map((elem) => {
              if (["country", "state", "city"].includes(elem.id)) {
                return (
                  <div key={elem.id} className="w-full mb-2">
                    <CustomSelect
                      key={elem.id}
                      id={elem.id}
                      label={elem.label}
                      value={formValues[elem.id] || ""}
                      options={elem.id==="country"?Country:elem.id==='state'?stats:cities || []}
                      isInvalid={invalidFields[elem.id]}
                      onChange={handleChange}
                      required={elem.required}
                    />
                  </div>
                );
              }
              return (
                <div key={elem.id} className="w-full mb-2">
                  <CustomInput
                    type={elem.type}
                    label={elem.label}
                    id={elem.id}
                    placeholder={elem.placeholder}
                    value={formValues[elem.id] || ""}
                    isInvalid={invalidFields[elem.id]}
                    onchange={(e) => handleChange(elem.id, e.target.value)}
                    required={elem.required}
                  />
                </div>
              );
            })}
          </div>
        </div>
      ))}
      <div className="flex justify-between items-center mt-6 px-7">
        <CustomButton
          type="button"
          text="Previous"
          onClick={() => setActiveTab(0)}
        />
        <CustomButton type="submit" text="Next" loading={isLoading} />
      </div>
    </form>
  );
};

export default Contact;